import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../../app/state/app.selectors';
import * as fromOebsConfig from './oebs-config.reducers';

export interface OebsConfigState {
  stateData: fromOebsConfig.State;
}

export interface State extends fromRoot.AppState {
  oebsConfig: OebsConfigState;
}

export const reducers = {
  stateData: fromOebsConfig.reducer
};

export const selectOebsConfigState = createFeatureSelector<OebsConfigState>('oebsConfig');

export const selectOebsConfigStateData = createSelector(selectOebsConfigState, (state: OebsConfigState) => state.stateData);

export const getOebsConfigState = createSelector(selectOebsConfigStateData, fromOebsConfig.getStateData);

export const getOebsConfigScreenError = createSelector(selectOebsConfigStateData, fromOebsConfig.getError);

export const getOebsConfigScreenPending = createSelector(selectOebsConfigStateData, fromOebsConfig.getPending);